import logo from 'images/communities/Chicago/logo.png'
import mapLogo from 'images/communities/Chicago/ingenuity-white.svg'
import dashboardHeaderImage from 'images/map/landing/home-hero.jpg'
import loginBackgroundImg from 'images/map/landing/kids-1.jpg'
import educatorLogo from 'images/communities/Chicago/Educator/educator-logo.svg'
import educatorSponsorLogo from 'images/communities/Chicago/Educator/cps-logo.png'
import favicon from 'images/communities/Chicago/favicon.png'
import homeLogo from 'images/home/community-logos/chicago.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/chicago-video-button-image.png'

const config = {
  subdomain: 'chicago',
  name: 'Chicago',
  position: 1,
  partnerSupportEmail: 'artlook@ingenuity-inc.org',
  schoolSupportEmail: 'artlook@ingenuity-inc.org',
  artistSupportEmail: 'artlook@ingenuity-inc.org',
  stylesheet: 'chicago.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://www.ingenuity-inc.org/',
  faqUrl:
    'https://drive.google.com/file/d/1nzK784ubj_NtLWWGYFd3-2pv3PPrGYdI/view?usp=sharing',
  faqUrlEducator:
    'https://drive.google.com/file/d/1uV8TfCYVkQ0_SubVJc7t9t3w1DfHaRpp/view?usp=sharing',
  howToVideos:
    'https://www.youtube.com/watch?v=cOl0Lk1kjFs&list=PLYgCWzolmg3Uu2uFrUhMFuP9_gwgBgbWr',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: true,
  schoolProfileCompletionEnabled: true,
  teachingArtistProfileCompletionEnabled: false,
  showRecentLoginOnPublicPage: true,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  educatorEnabled: true,
  notificationsEnabled: true,
  notificationListSize: 100,
  dataDashboardEnabled: false,
  partnerRegisterEnabled: false,
  id: 3,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: false,
  registerEnabled: false,
  provideOwnPrograms: false,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: [],
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 41.878292, lng: -87.622578 },
    radius: 40, //in miles
  },
  directoryFilters: {
    blockList: [
      'coursesOffered',
      'creativeSchoolsCategory',
      'instructorsTeaching',
      'partnerProgramTypes',
      'partnersCount',
      'programTypes',
      'resourceProgramOutcomeInterests',
      'resourceTypes',
      'schoolDistrict',
      'schoolTypes',
      'schoolYears',
      'studentDemographics',
      'subDisciplines',
      'schools',
      'topics',
      'users',
      'networks',
      'outcomeTypes',
      'financialAssistanceTypes',
      'openToPartnerships',
    ],
  },
  forumFilters: {
    blockList: [
      'coursesOffered',
      'creativeSchoolsCategory',
      'instructorsTeaching',
      'partnerProgramTypes',
      'partnersCount',
      'programTypes',
      'resourceProgramOutcomeInterests',
      'resourceTypes',
      'schoolDistrict',
      'schoolYears',
      'studentDemographics',
      'subDisciplines',
      'gradesServed',
      'networks',
      'neighborhoods',
      'outcomeTypes',
      'financialAssistanceTypes',
      'openToPartnerships',
    ],
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'default-community',
  favicon,
  mapLogo: {
    src: mapLogo,
    alt: "Ingenuity's homepage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Ingenuity',
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: dashboardHeaderImage,
    alt: '',
  },
  educatorLogo: {
    src: educatorLogo,
    alt: "Chicago's artlook Educator",
  },
  educatorSponsorLogo: {
    src: educatorSponsorLogo,
    alt: 'Chicago Public Schools',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: Increasing Arts Education in Chicago Public Schools',
    searchHeader: 'Find Schools & Partners in Chicago',
    cscLinkText: 'Creative Schools Certification Roadmap',
    welcomeSearchHeader: 'Explore Arts Education in Chicago',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Chicago</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
            Developed by Ingenuity in Chicago and customized through a local collaboration among CPS teachers, school 
            and district leaders, and arts organizations, artlook® provides a historical and real-time picture of the 
            people, places, and programs supporting arts education in Chicago.
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public map, artlook® drives and strengthens the way Ingenuity gathers, analyzes, 
            disseminates, and activates data for the arts education sector in Chicago. Together, these tools support a 
            more equitable, vibrant, and diverse arts education system across our region.
          </p>
          <p>
            Ingenuity welcomes schools and arts organizations to collaborate on artlook<sup>®</sup> ${config.name}. To 
            learn about eligibility or get listed on the map, contact us at 
            <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Data`,
      text: `
        <p>
          Explore the map to discover where and what arts programs exist—and where they’re still needed. View data on 
          access and partnerships across CPS schools.  
        </p>
        <p>
          Looking to go deeper? Reach out to 
          <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a> 
          for customized insights and additional resources to support your work.      
        </p>
      `,
    },
    findProgramsCard: {
      title: `Use The Data`,
      text: `
        <p>
          Tap into data on arts access such as courses and instructors, partnerships, and student reach, to strengthen 
          grants, shape programming, and support informed decisions. artlook® helps you design with insight and advocate 
          with impact.
        </p>
      `,
    },
    findDataCard: {
      title: `Make Connections`,
      text: `
        <p>
          Use the map to build partnerships that support arts education by connecting schools, arts organizations, and 
          teaching artists who share your goals. The map includes contact information to help you reach out and start 
          collaborating easily.
        </p>
      `,
    },
    justExploreCard: {
      title: `Just Explore`,
      text: `
      <p>
        Explore the most comprehensive picture of arts education in Chicago. See where the arts are thriving—and where 
        more opportunities are needed.
      </p>
    `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This exclusive map provides the most complete insight into arts education in Chicago. It captures information 
        on arts education programs from CPS schools, arts organizations, and teaching artists.
      <p>
        Use the search function above to explore arts education programs and resources available to students in schools 
        and through arts partners, and get an up-to-date snapshot of where arts education is happening, what’s being 
        offered, and who’s involved.      
      </p>
      <p>
        Are you part of this work? Log in to report or update your data. Your input helps us tell a more complete story 
        of arts education, supports advocacy, and strengthens our collective impact. This data is published annually in Ingenuity's 
        <a href="https://www.ingenuity-inc.org/data-research/state-of-the-arts/" target="_blank" rel="noopener noreferrer">State of the Arts</a> and informs our 
        <a href="https://www.ingenuity-inc.org/data-research/" target="_blank" rel="noopener noreferrer">Data & Research</a> 
        work. Go explore and connect to bring more arts to more CPS students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/OeqCbofkUi8?si=988vOCj6wdLTqNEW&amp;controls=0',
      iframeTitle: 'Chicago artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  tagline:
    'Expanding Arts Education. Advancing Equity. Empowering Chicago Public School (CPS) Students.',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Chicago</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Chicago</em> is the only platform of its kind that combines data from Chicago-area public schools and arts education program providers (like you!). The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p><strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong></p>
        <p>If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.</p>
    `,
    },
  },
  surveyCompletionModal: `
      <h2>Survey Complete!</h2>
      <br />
      <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
      <br />
      <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
    `,
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Chicago</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Chicago</em> is the only platform of its kind that combines data from Chicago-area public schools (like you!) and arts education program providers. The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
            <strong>
            To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.
            </strong>
        </p>
        <p>If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>
      `,
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
  educatorPortal: {
    welcomeMessage: `
        <h3>Welcome to Chicago's <em>artlook<sup>®</sup></em> Educator!</h3>
        <p>
          Find, Connect, and Collaborate with your Colleagues!
        </p>
      `,
  },
  learningHub: {
    welcomeMessage: `
        <h2>Welcome to the artlook Learning Hub!</h2>
        <p>
          This platform is your central space for learning, collaboration, and
          growth. Whether you're exploring new skills, completing professional
          training, or sharing creative ideas, this LMS is designed to make your
          learning experience engaging and easy to navigate.
        </p>
        <p>
          If you have any questions or need assistance, please contact
          <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
        </p>
      `,
  },
  survey: {
    getStarted: `<h2>Welcome to the {{ surveySchoolYearNumber }} Creative Schools Survey!</h2>
    <p>Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e. arts organizations), and how your school budgets and plans for the arts.</p>
    <p>As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting.</p>
    <p>Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions!</p>`,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day. Note that district-run/district-managed schools require arts instructors to hold an ISBE certification or endorsement in one of the four state-recognized disciplines (visual arts, music, theater, and/or dance). Charter schools, contract schools, and Pre-K-only schools do not have this requirement. The media arts discipline does not have an ISBE certification/endorsement; these instructors should be listed as well.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status for the entire school year. If a teacher was part-time for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.GENERAL,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

// ----- EDUCATOR CONFIG -----

config.educator = {
  communityOfPracticeEnabled: true,
}

export default config
